<template>
    <div class="f-action-bar">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: 'FActionBar'
    }
</script>

<style lang="stylus">
    .f-action-bar
        display flex
        flex-direction column
        align-items flex-end
        gap .4rem
        width 100%

    @media screen and (max-width: 768px)
        .f-action-bar
            align-items stretch
</style>
